import ModalNewClass from '../modals/ModalNewClass.vue'

export default {
	methods: {
		openNewClassModal: function() {
			this.modals.ModalNewClass.show = true;
		}
	},
	components: {
		ModalNewClass
	}
}